export default "__VITE_ASSET__c22b06cb__"